import React, { createElement } from "react";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { RichText } from "../utils/richText";
import linkResolver from "../utils/linkResolver";
import { motion } from "framer-motion";
import { getTagType, getFirstArrayItem } from "../utils/utils";
import { FADE_UP, FADE_LEFT, FADE_RIGHT } from "./animationUtils";
import { HubspotProvider, useHubspotForm } from "react-use-hubspot-form";

export const fragments = graphql`
  fragment Page_HubspotSpeakExpertForm on PrismicPageDataBodyHubspotSpeakExpertForm {
    id
    slice_type
    primary {
      hubspot_form_expert_heading {
        text
        richText
        html
      }
      hubspot_form_expert_desc {
        text
        richText
        html
      }
      hubspot_form_expert_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      hubspot_form_expert_name {
        text
        richText
        html
      }
      hubspot_form_expert_title {
        text
        richText
        html
      }
      hubspot_form_expert_form_region {
        text
      }
      hubspot_form_expert_form_portal_id {
        text
      }
      hubspot_form_expert_form_id {
        text
      }
      hubspot_form_expert_text_color
      hubspot_form_expert_bg_color
    }
  }

  fragment FocusArea_HubspotSpeakExpertForm on PrismicFocusAreaDataBodyHubspotSpeakExpertForm {
    id
    slice_type
    primary {
      hubspot_form_expert_heading {
        text
        richText
        html
      }
      hubspot_form_expert_desc {
        text
        richText
        html
      }
      hubspot_form_expert_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      hubspot_form_expert_name {
        text
        richText
        html
      }
      hubspot_form_expert_title {
        text
        richText
        html
      }
      hubspot_form_expert_form_region {
        text
      }
      hubspot_form_expert_form_portal_id {
        text
      }
      hubspot_form_expert_form_id {
        text
      }
      hubspot_form_expert_text_color
      hubspot_form_expert_bg_color
    }
  }

  fragment Project_HubspotSpeakExpertForm on PrismicProjectDataBodyHubspotSpeakExpertForm {
    id
    slice_type
    primary {
      hubspot_form_expert_heading {
        text
        richText
        html
      }
      hubspot_form_expert_desc {
        text
        richText
        html
      }
      hubspot_form_expert_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 600)
      }
      hubspot_form_expert_name {
        text
        richText
        html
      }
      hubspot_form_expert_title {
        text
        richText
        html
      }
      hubspot_form_expert_form_region {
        text
      }
      hubspot_form_expert_form_portal_id {
        text
      }
      hubspot_form_expert_form_id {
        text
      }
      hubspot_form_expert_text_color
      hubspot_form_expert_bg_color
    }
  }
`;

const HubspotSpeakExpertFormProvider = ({ data }) => {
  useHubspotForm({
    region: data?.primary?.hubspot_form_expert_form_region?.text,
    portalId: data?.primary?.hubspot_form_expert_form_portal_id?.text,
    formId: data?.primary?.hubspot_form_expert_form_id?.text,
    target: "#hubspotSpeakForm",
  });

  let HubspotSpeakExpertFormHeading =
    data?.primary?.hubspot_form_expert_heading?.richText;
  let HubspotSpeakExpertFormDesc =
    data?.primary?.hubspot_form_expert_desc?.richText;
  let HubspotSpeakExpertFormName =
    data?.primary?.hubspot_form_expert_name?.richText;
  let HubspotSpeakExpertFormTitle =
    data?.primary?.hubspot_form_expert_title?.richText;

  return (
    <div
      className="hubspot-speak-expert-form-section"
      style={{
        backgroundColor:
          data?.primary?.hubspot_form_expert_bg_color ?? "#002B41",
        color: data?.primary?.hubspot_form_expert_text_color ?? "#FFFFFF",
      }}
    >
      <motion.div className="heading-col" {...FADE_LEFT}>
        <motion.div {...FADE_UP}>
          {createElement(
            getTagType(
              getFirstArrayItem(HubspotSpeakExpertFormHeading)?.type
            ) ?? "h2",
            { className: `h5 heading__title` },
            data?.primary?.hubspot_form_expert_heading?.text
          )}
        </motion.div>
        {HubspotSpeakExpertFormDesc !== "" && (
          <motion.div className="heading__desc" {...FADE_UP}>
            {RichText(HubspotSpeakExpertFormDesc, linkResolver)}
          </motion.div>
        )}
        <div id="hubspotSpeakForm" className="hubspot-form-container"></div>
      </motion.div>
      <motion.div className="image-col" {...FADE_RIGHT}>
        {data?.primary?.hubspot_form_expert_image?.gatsbyImageData && (
          <GatsbyImage
            image={data?.primary?.hubspot_form_expert_image?.gatsbyImageData}
            alt={data?.primary?.hubspot_form_expert_image?.alt}
            class="image__wrapper"
          />
        )}
        <motion.div {...FADE_UP}>
          {createElement(
            getTagType(getFirstArrayItem(HubspotSpeakExpertFormName)?.type) ??
              "h3",
            { className: `h5 image__name` },
            data?.primary?.hubspot_form_expert_name?.text
          )}
        </motion.div>
        <div className="image__title">
          {RichText(HubspotSpeakExpertFormTitle, linkResolver)}
        </div>
      </motion.div>
    </div>
  );
};

const HubspotSpeakExpertForm = ({ data }) => {
  return (
    <HubspotProvider>
      <HubspotSpeakExpertFormProvider data={data} />
    </HubspotProvider>
  );
};

export default HubspotSpeakExpertForm;
